import {
  addPermissionsToRoute,
  addAdminOnlyRoute,
  addTestRoute,
  addEnterpriseClientCheck,
} from '@qsrsoft/myq-core';

export default [
  {
    path: '/test',
    name: 'Admin Page 2',
    icon: 'mdi-test-tube',
    component: () => import('./test2.vue'),
    ...addAdminOnlyRoute(),
  },
  // {
  //   path: '/releaseNotes',
  //   name: 'Release Notes',
  //   icon: 'mdi-text',
  //   component: () => import('./ReleaseNotes.vue'),
  // },
  // user routes
  {
    name: 'Organization',
    icon: 'mdi-office-building-outline',
    path: '/organization',
    children: [
      {
        path: '/organization/orgPatches',
        name: 'Patches',
        meta: { id: 'admin-org-patches' },
        component: () => import('./patches/Patches.vue'),
        ...addPermissionsToRoute(['permissions_access']),
      },
      {
        path: '/organization/orgTimeslices',
        name: 'Time Slices',
        meta: { id: 'admin-org-time-slices' },
        component: () => import('./timeSlices/TimeSlices.vue'),
        ...addPermissionsToRoute(['permissions_access']),
      },
      {
        path: '/organization/orgWatchlists',
        name: 'Watch Lists',
        meta: { id: 'admin-org-watch-lists' },
        component: () => import('./watchLists/main.vue'),
        ...addPermissionsToRoute(['permissions_access']),
      },
      {
        path: '/organization/orgSettings',
        name: 'Settings',
        meta: { id: 'admin-org-settings' },
        component: () => import('./orgSettings/OrgSettings.vue'),
        ...addPermissionsToRoute(['permissions_access']),
      },
    ],
  },
  {
    name: 'Alerts',
    icon: 'mdi-bell',
    path: '/alerts',
    children: [
      {
        path: '/alerts',
        name: 'Alerts All',
        meta: { id: 'admin-alerts-all' },
        component: () => import('./alerts/Alerts.vue'),
      },
      {
        path: '/alerts/:notificationId',
        name: 'Alert Detail',
        meta: { id: 'admin-alert-detail' },
        component: () => import('./alerts/AlertDetail.vue'),
      },
      {
        path: '/alerts/settings',
        name: 'Alerts settings',
        meta: { id: 'admin-alerts-settings' },
        component: () => import('./alerts/AlertsSettings.vue'),
      },
      {
        path: '/scheduledReports',
        name: 'Scheduled Reports',
        meta: { id: 'admin-scheduled-reports' },
        component: () => import('./scheduledReports/ScheduledReports.vue'),
      },
    ],
  },
  {
    path: '/businessUnit',
    name: 'Business Unit',
    icon: 'mdi-store-outline',
    meta: { id: 'admin-business-unnit' },
    component: () => import('./businessUnit/BusinessUnit.vue'),
    ...addPermissionsToRoute(['permissions_access']),
  },
  {
    name: 'Missing Geids',
    icon: 'mdi-account-alert',
    path: '/missingGeids',
    meta: { id: 'admin-missing-geids' },
    component: () => import('./onboarding/MissingGeids.vue'),
    ...addAdminOnlyRoute(),
  },
  {
    name: 'GEID User Lookup',
    icon: 'mdi-account-search',
    path: '/geidLookup',
    meta: { id: 'admin-geid-lookup' },
    component: () => import('./onboarding/GeidUserLookup.vue'),
    ...addAdminOnlyRoute(),
  },
  {
    name: 'Onboarding Communication',
    path: '/onboarding/communication',
    meta: { id: 'admin-onboarding-communication' },
    component: () => import('./onboarding/OnboardingCommunication.vue'),
    ...addAdminOnlyRoute(),
  },
  {
    name: 'Chat Audit',
    icon: 'mdi-chat-question-outline',
    path: '/chatAudit',
    meta: { id: 'admin-chat-audit' },
    component: () => import('./chatAudit/ChatAudit.vue'),
    ...addAdminOnlyRoute(),
  },
  {
    name: 'Legacy Users',
    icon: 'mdi-account',
    path: '/legacyUsers',
    meta: { id: 'admin-legacy-users' },
    component: () => import('./users/UserList.vue'),
    ...addAdminOnlyRoute(),
  },

  {
    name: 'Subscriptions',
    icon: 'mdi-account',
    path: '/subscriptions',
    meta: { id: 'admin-subscriptions' },
    component: () => import('./subscriptions/Subscriptions.vue'),
    ...addAdminOnlyRoute(),
    ...addEnterpriseClientCheck(['McDonalds']),
  },
  {
    name: 'Users',
    icon: 'mdi-account',
    path: '/users',
    meta: { id: 'admin-users' },
    component: () => import('./users/UsersPage.vue'),
    ...addPermissionsToRoute(['permissions_access']),
  },
  {
    name: 'Locations',
    icon: 'mdi-map-marker',
    path: '/locations',
    component: () => import('./locations/LocationsPage.vue'),
    ...addPermissionsToRoute(['permissions_access']),
  },
  {
    name: 'Roles',
    icon: 'mdi-account-key',
    path: '/roles',
    component: () => import('./roles/RolesPage.vue'),
    ...addPermissionsToRoute(['permissions_access']),
  },
  {
    name: 'Your Profile',
    path: '/user/account',
    meta: { id: 'admin-your-profile' },
    component: () => import('./profile/ProfilePage.vue'),
  },
  {
    name: 'Hierarchy',
    path: '/hierarchy',
    meta: { id: 'admin-hierarchy' },
    component: () => import('./hierarchy/hierarchy_page.vue'),
    ...addPermissionsToRoute(['permissions_access']),
  },
  {
    name: 'Rewards',
    icon: 'mdi-trophy-outline',
    path: '/rewards',
    meta: { id: 'admin-rewards' },
    component: () => import('./rewards/rewardsSettings.vue'),
    ...addPermissionsToRoute(['permissions_access']),
  },
  {
    name: 'Access Requests',
    icon: 'mdi-account-request-outline',
    path: '/access-requests',
    meta: { id: 'admin-access-requests' },
    component: () => import('./onboarding/accessRequests/AccessRequests.vue'),
    ...addTestRoute(),
  },
];
